import Text from './Text'
export default Text;
export { Text }